<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SDlWFR/tc-custom/9781497694170.jpg?1705807610698" alt="This image is the cover for the book Now You See Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Now You See Me
      </h1>
      <p class="bookDescription body article font2">
        <b>An orphan and a fugitive find a connection in their secret pasts in this “</b><b>love story that moves with the pace of a thriller” from an award-winning author (<i>Yorkshire Post</i>).</b><br/>  <br/> At sixteen, Lamb walks out on her life. Her parents are dead and she has no brothers or sisters. For money, she cleans people’s homes. For shelter, she lives in the cellar of an elderly client. For survival, she imagines herself as a tightrope walker—one foot in front of the other, eyes straight ahead, and never allowing anyone to touch her, lest she lose her balance. Then she meets Doggo. And Lamb can feel herself falling.<br/>  <br/> Doggo walked out on his life, too—or more precisely, he ran. A fugitive fleeing from a violent criminal past, he needs Lamb’s help staying under the radar. Quick-tempered, foul-mouthed, yet surprisingly tender, Doggo needs Lamb in other ways, too. But the closer they get, the more Lamb risks her precarious balance between life and death. And fear has never felt so comforting.<br/>  <br/><i>Now You See Me, </i>from Somerset Maugham Award winner Lesley Glaister, is an empowering novel about loneliness, trust, the fictions we tell ourselves to survive, and the primal need to connect. It also “boasts a protagonist so heartbreakingly well-realized that you are forced to live through her eyes, in her head, her heart . . . if only all fiction made us worry and care so hard, posed us such dreadfully difficult questions” (<i>The Guardian</i>).<br/>  <br/> “Glaister is at her best . . . written in the crisply poetic prose for which she’s known, [she] transforms the bleakest situations into compelling fiction.” —<i>The Independent</i><br/>  <br/> “Before Gillian Flynn, there was Lesley Glaister.” —<i>Harper’s Bazaar</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lesley Glaister
      </h2>
      
      <p class="authorDescription body article">Lesley Glaister&#160;(b. 1956) is a British novelist, playwright, and teacher of writing, currently working at the University of St Andrews. She is a fellow of the Royal Society of Literature and a member of the Society of Authors. Her first novel,&#160;<I>Honour Thy Father</I>, was published in 1990 and received both a Somerset Maugham Award and a Betty Trask Award. Glaister became known for her darkly humorous works and has been dubbed the Queen of Domestic Gothic. Glaister was named Yorkshire Author of the Year in 1998 for her novel&#160;<I>Easy Peasy</I>, which was shortlisted for the Guardian&#160;Fiction Award in 1998.&#160;<I>Now You See Me&#160;</I>was shortlisted for the Orange Prize for Fiction in 2002. Glaister lives in Edinburgh, Scotland, with her husband, author Andrew Greig.<BR /> &#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c2b070a